/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptions_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_viewer">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptions_viewer";
};
export type PdpSharedDescriptionAdditionalOptions_viewer$data = PdpSharedDescriptionAdditionalOptions_viewer;
export type PdpSharedDescriptionAdditionalOptions_viewer$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptions_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'a9b9df2199ac342c794d8791e7f2bcb9';
export default node;
